var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('intersect',{on:{"enter":_vm.handleEnter,"leave":_vm.handleLeave}},[_vm._t("default",null,null,{ shouldRender: _vm.shouldRender })],2)}
var staticRenderFns = []

export { render, staticRenderFns }